import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedPageModule } from '@Work/Accounts/proprietary/pages/shared-page.module';
import { ValidationDialogComponent } from './validation-dialog.component';

@NgModule({
    imports: [SharedPageModule, NgbTooltipModule],
    declarations: [ValidationDialogComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ValidationDialogModule { }
